"use client"

import React, { Suspense } from "react"

import ImageGallery from "@modules/products/components/image-gallery"
import ProductActions from "@modules/products/components/product-actions"
import ProductTabs from "@modules/products/components/product-tabs"
import ProductInfo from "@modules/products/templates/product-info"
import { notFound } from "next/navigation"
import { HttpTypes } from "@medusajs/types"

type ProductTemplateProps = {
  product: HttpTypes.StoreProduct
  region: HttpTypes.StoreRegion
  countryCode: string
}

const ProductTemplate: React.FC<ProductTemplateProps> = ({
  product,
  region,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  countryCode,
}) => {
  if (!product || !product.id) {
    return notFound()
  }

  const [options, setOptions] = React.useState<
    Record<string, string | undefined>
  >({})
  return (
    <>
      <div
        className="content-container flex flex-col medium:flex-row medium:items-start py-8 medium:pt-20 px-6 sm:px-10 lg:px-16 relative max-w-[1280px] mx-auto gap-8"
        data-testid="product-container"
      >
        {/* Outer corner markers removed */}

        {/* Image Gallery - First on mobile/tablet, middle on desktop */}
        <div className="block w-full relative order-first medium:order-2 medium:px-8 spark-card py-8">
          {/* Corner markers */}
          <div className="corner-marker corner-marker-tl"></div>
          <div className="corner-marker corner-marker-tr"></div>
          <div className="corner-marker corner-marker-bl"></div>
          <div className="corner-marker corner-marker-br"></div>
          <span className="typography-marker top-6">02</span>
          <ImageGallery images={product?.images || []} options={options} />
        </div>

        {/* Product Actions - Second on mobile/tablet, first on desktop */}
        <div className="flex flex-col medium:py-0 medium:max-w-[300px] w-full py-4 medium:py-8 gap-y-8 order-2 medium:order-1 medium:pr-8 spark-card relative px-6">
          {/* Corner markers */}
          <div className="corner-marker corner-marker-tl"></div>
          <div className="corner-marker corner-marker-tr"></div>
          <div className="corner-marker corner-marker-bl"></div>
          <div className="corner-marker corner-marker-br"></div>
          <span className="typography-marker top-6">01</span>
          <Suspense
            fallback={
              <ProductActions
                disabled={true}
                product={product}
                region={region}
                options={{}}
                setOptions={() => {}}
              />
            }
          >
            <ProductActions
              product={product}
              region={region}
              options={options}
              setOptions={setOptions}
            />
          </Suspense>
        </div>

        {/* Product Info - Third on both mobile/tablet and desktop */}
        <div className="flex flex-col medium:py-0 medium:max-w-[300px] w-full py-4 medium:py-8 gap-y-8 order-3 medium:pl-8 spark-card relative px-6">
          {/* Corner markers */}
          <div className="corner-marker corner-marker-tl"></div>
          <div className="corner-marker corner-marker-tr"></div>
          <div className="corner-marker corner-marker-bl"></div>
          <div className="corner-marker corner-marker-br"></div>
          <span className="typography-marker top-6">03</span>
          <ProductInfo product={product} />
          <ProductTabs product={product} />
        </div>
      </div>
    </>
  )
}

export default ProductTemplate
